import { validateDemo } from '../../../../shared/api/demo.js'
import { step } from './status.js'

export const VERIFICATION_UPDATE = 'VERIFICATION_UPDATE'
export const VERIFICATION_VALIDATING = 'VERIFICATION_VALIDATING'
export const VERIFICATION_ERROR = 'VERIFICATION_ERROR'

export function validate(preauthToken, code, firstName, lastName) {
	return (dispatch, getState) => {
		dispatch({ type: VERIFICATION_VALIDATING })

		return validateDemo(preauthToken, code, firstName, lastName).then(response => {

			dispatch(update({ code, verified: true }))
			dispatch(step('complete'))

		}).catch(err => {

			let errorMessage = 'An unknown server error has occurred [D10]'

			if (err.response) {
				// API response provided
				switch (err.response.status) {
					case 400: {
						err.response.json().then(res => {
							const { message } = res
							errorMessage = message || 'Invalid verification code [D06]'
							dispatch({ type: VERIFICATION_ERROR, payload: errorMessage })
						})
						return // Don't dispatch error yet, wait for json parsing
					}

					case 404: {
						errorMessage = 'Verification code not found or expired [D07]'
					} break

					case 500: {
						errorMessage = 'Registration service unavailable [D08]'
					} break

					default: {
						errorMessage = 'An unknown error has occurred [D09]'
					} break
				}
			}

			dispatch({ type: VERIFICATION_ERROR, payload: errorMessage })
		})
	}
}

export function update(payload) {
	return {
		type: VERIFICATION_UPDATE,
		payload
	}
}
